import { UploadFile } from 'antd'
import { StandardStrapiFields } from '../strapi/strapi'
import Machine from './machine'
import PrintJob from './print-job'
import User from './user'

export default interface PrintJobExecutor extends StandardStrapiFields {
    user: User // пользователь
    machine: Machine // станок
    start: string // время начала работ
    end?: string // время окончания работ
    photos?: UploadFile[] // фотоотчет о выполнении работ
    reason?: Reasons // причина завершения
    print_job?: PrintJob // задание печати
}

export enum Reasons {
    Done = 'Готово', // допечатал
    ClosingShift = 'Закрытие смены',
    Cancel = 'Отменен',
}
